import _get from 'lodash/get';
import APPCONFIG from '../../../constants/Config';
import { REINIT_STATE, CPM_INITIATE_PAYMENT, CPM_REFUND_PURCHASE } from '../../../constants/ActionTypes';
// Models
/* eslint-disable import/named */
import { deserializePurchase } from '../../../models/cpm/finance';
/* eslint-enable import/named */

const initialSettings = APPCONFIG.cpmFinance;

const finance = (state = initialSettings, action) => {
  switch (action.type) {
    // REINIT STATE
    case REINIT_STATE:
      if (action.target === 'initiatePayment') {
        return {
          ...state,
          purchase: { ...initialSettings.purchase },
        };
      }
      return state;
    // CPM_INITIATE_PAYMENT
    case CPM_INITIATE_PAYMENT:
      return {
        ...state,
        purchase: {
          ...state.purchase,
          error: null,
          loading: true,
          result: null,
        },
      };
    case `${CPM_INITIATE_PAYMENT}_ERROR`:
      return {
        ...state,
        purchase: {
          ...state.purchase,
          error: action.error,
          loading: false,
        },
      };
    case `${CPM_INITIATE_PAYMENT}_SUCCESS`:
      return {
        ...state,
        purchase: {
          ...state.purchase,
          loading: false,
          result: deserializePurchase(action.data.initiatePayment),
        },
      };
    // CPM_REFUND_PURCHASE
    case CPM_REFUND_PURCHASE:
      return {
        ...state,
        purchase: {
          ...state.purchase,
          error: null,
          loading: true,
          refunded: false,
        },
      };
    case `${CPM_REFUND_PURCHASE}_ERROR`:
      return {
        ...state,
        purchase: {
          ...state.purchase,
          error: _get(action, 'error.errors[0].message', null),
          loading: false,
        },
      };
    case `${CPM_REFUND_PURCHASE}_SUCCESS`:
      return {
        ...state,
        purchase: {
          ...state.purchase,
          loading: false,
          refunded: deserializePurchase(_get(action, 'data.refundPurchase', null)),
        },
      };
    default:
      return state;
  }
};

export default finance;



// WEBPACK FOOTER //
// ./reducers/cpm/finance/finance.js